// Foreign Accents Bespoke: product gallery and full-screen photo view.
for (const gallery of document.querySelectorAll('[data-gallery]')) {
  const stage = gallery.querySelector('[data-gallery-stage]');
  const slides = [...gallery.querySelectorAll('.gallery__slide')];
  const thumbs = [...gallery.querySelectorAll('[data-gallery-thumb]')];
  const openers = [...gallery.querySelectorAll('[data-gallery-open]')];
  const lightbox = gallery.querySelector('[data-lightbox]');
  if (!stage || !lightbox) continue;

  /* ---------- Thumbnails scroll the stage; the stage marks the current thumbnail ---------- */

  const goTo = (index) => {
    stage.scrollTo({ left: slides[index].offsetLeft - stage.offsetLeft, behavior: 'smooth' });
  };
  const markThumb = (index) => {
    thumbs.forEach((thumb, i) => thumb.setAttribute('aria-current', String(i === index)));
  };

  for (const thumb of thumbs) {
    thumb.addEventListener('click', (event) => {
      event.preventDefault();
      const index = Number(thumb.dataset.galleryThumb);
      goTo(index);
      markThumb(index);
    });
  }

  if (thumbs.length) {
    const observer = new IntersectionObserver((entries) => {
      for (const entry of entries) if (entry.isIntersecting) markThumb(Number(entry.target.dataset.index));
    }, { root: stage, threshold: 0.6 });
    slides.forEach((slide) => observer.observe(slide));
  }

  /* ---------- Full-screen view with click-to-zoom ---------- */

  const img = lightbox.querySelector('[data-lightbox-img]');
  const viewport = lightbox.querySelector('[data-lightbox-viewport]');
  const count = lightbox.querySelector('[data-lightbox-count]');
  let current = 0;

  const unzoom = () => lightbox.removeAttribute('data-zoomed');

  const showPhoto = (index) => {
    current = (index + openers.length) % openers.length;
    const source = openers[current].dataset;
    unzoom();
    img.src = source.full;
    img.width = Number(source.width);
    img.height = Number(source.height);
    img.alt = source.alt || '';
    count.textContent = openers.length > 1 ? `${current + 1} / ${openers.length}` : '';
  };

  openers.forEach((opener, index) => {
    opener.addEventListener('click', () => {
      showPhoto(index);
      lightbox.showModal();
    });
  });

  lightbox.querySelector('[data-lightbox-close]').addEventListener('click', () => lightbox.close());
  for (const step of lightbox.querySelectorAll('[data-lightbox-step]')) {
    step.addEventListener('click', () => showPhoto(current + Number(step.dataset.lightboxStep)));
  }

  lightbox.addEventListener('close', () => {
    unzoom();
    goTo(current);
    markThumb(current);
    openers[current].focus({ preventScroll: true });
  });

  lightbox.addEventListener('keydown', (event) => {
    if (event.key === 'ArrowRight') showPhoto(current + 1);
    else if (event.key === 'ArrowLeft') showPhoto(current - 1);
  });

  // Zoom shows the photo at full size (at least twice the fitted size), centred on the click point.
  img.addEventListener('click', (event) => {
    if (lightbox.hasAttribute('data-zoomed')) {
      unzoom();
      return;
    }
    const rect = img.getBoundingClientRect();
    const fx = (event.clientX - rect.left) / rect.width;
    const fy = (event.clientY - rect.top) / rect.height;
    const width = Math.max(img.naturalWidth || rect.width * 2, rect.width * 2);
    lightbox.style.setProperty('--zoom-width', `${width}px`);
    lightbox.setAttribute('data-zoomed', '');
    const height = width * (rect.height / rect.width);
    viewport.scrollTo(fx * width - viewport.clientWidth / 2, fy * height - viewport.clientHeight / 2);
  });

  // Swipe between photos on touch screens when not zoomed.
  let startX = null;
  viewport.addEventListener('pointerdown', (event) => {
    if (event.pointerType === 'touch' && !lightbox.hasAttribute('data-zoomed')) startX = event.clientX;
  });
  viewport.addEventListener('pointerup', (event) => {
    if (startX === null) return;
    const dx = event.clientX - startX;
    startX = null;
    if (Math.abs(dx) > 50) showPhoto(current + (dx < 0 ? 1 : -1));
  });
}
